module.exports = __webpack_public_path__ + "static/logo-7731f972ab2ab1680286de8461d004ca.png";